import { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import EntityDetailPopup from '../../utility/EntityDetailPopup';
import { popupClasses } from '../../utility';

const itemKeys = ['item_name', 'category_name', 'category_type', 'quantity_type', 'unit_name', 'strain_name'];

export default function CreateItemPopup(props) {
  const {
    collectionData = {},
    currDarkThemeClass = '',
    handleAddItem,
    handleSetValues,
    handlePopupClose,
    headContentText,
    open,
    values,
    selectedFarm = [],
    farmDetails = [],

    ...otherProps
  } = props;
  const [values2, setValues2] = useState({});
  const [error, setError] = useState(false);

  const itemCategories = collectionData.itemcategory || [];
  const unitList = collectionData.unit || [];
  const strainList = collectionData.strain || [];

  const cSPTextFieldProps = ({ prop, inputProps = {}, otherTextProps = {} }) => ({
    autoComplete: 'off',
    className: `${popupClasses?.createStrain?.textField} ${currDarkThemeClass}`,
    fullWidth: true,
    inputProps,
    label: ' ',
    onChange: ({ target: { value } }) => handleSetValues(prop, value),
    required: true,
    value: values?.[prop] ?? '',
    ...otherTextProps,
  });

  const handleSaveClick = async () => {
    if (itemKeys.some(e => !values[e])) {
      // Handle validation error
      console.log(
        'Validation error:',
        itemKeys.filter(e => !values[e])
      );
      return;
    }

    handleSetValues('loading', true);

    let res = { success: false };

    try {
      res = await handleAddItem(values);
    } catch (error) {
      console.error('Error adding item:', error);
    } finally {
      handleSetValues('loading', false);
    }

    if (res?.success) {
      setValues2({});
      otherProps.onClose();
    }
  };

  const onPopupClose = () => {
    // setValues2({});
    handleSetValues('item_name', '');
    handleSetValues('category_name', '');
    handleSetValues('category_type', '');
    handleSetValues('quantity_type', '');
    handleSetValues('unit_name', '');
    handleSetValues('strain_name', '');
    handleSetValues('loading', false);
    otherProps.onClose();
  };

  const entityDetailPopupProps = {
    currDarkThemeClass,
    loading: values?.loading,
    toDisableSave: itemKeys.some(e => !values[e]) || error,
    onSaveClick: handleSaveClick,
    headContentText: ' ',
    title: 'Add Item',
    open,
    onClose: onPopupClose,
    ...otherProps,
  };

  const itemNameProps = {
    otherTextProps: {
      autoFocus: true,
      label: 'Item Name',
    },
    prop: 'item_name',
  };
  const categoryNameProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Category Name',
      type: 'text',
    },
    prop: 'category_name',
  };
  const categoryTypeProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Category Type',
      type: 'text',
    },
    prop: 'category_type',
  };
  const QuantityTypeProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Quantity Type',
      type: 'text',
    },
    prop: 'quantity_type',
  };
  const UnitNameProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Unit Name',
      type: 'text',
    },
    prop: 'unit_name',
  };
  const strainNameProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Strain Name',
      type: 'text',
    },
    prop: 'strain_name',
  };

  return (
    <EntityDetailPopup {...entityDetailPopupProps}>

      <TextField
        select
        {...cSPTextFieldProps({
          prop: 'category_name',
          otherTextProps: { label: 'Category Name' },
        })}
        onChange={e => {
          const selected = itemCategories.find(cat => cat.category_name === e.target.value);
          handleSetValues('category_name', selected.category_name);
          handleSetValues('category_type', selected.category_type);
          handleSetValues('quantity_type', selected.quantity_type);
          handleSetValues('unit_name', ''); // Clear unit if quantity_type changed
        }}
      >
        {itemCategories.map(cat => (
          <MenuItem key={cat.id} value={cat.category_name}>
            {cat.category_name}
          </MenuItem>
        ))}
      </TextField>
      {/* <TextField {...cSPTextFieldProps(categoryTypeProps)} />
      <TextField {...cSPTextFieldProps(QuantityTypeProps)} /> */}
      <TextField
        {...cSPTextFieldProps({
          prop: 'category_type',
          otherTextProps: { label: 'Category Type' },
        })}
        disabled
      />
      <TextField
        {...cSPTextFieldProps({
          prop: 'quantity_type',
          otherTextProps: { label: 'Quantity Type' },
        })}
        disabled
      />
            <TextField
        value={selectedFarm ? `${selectedFarm.farm_name} [${selectedFarm.license_number}]` : 'No Farm Selected'}
        className={`${popupClasses?.createStrain?.textField} ${currDarkThemeClass}`}
        fullWidth
        required
        label="Selected Farm"
        InputProps={{
          readOnly: true, // Make the input read-only
          ...cSPTextFieldProps({ prop: 'farm_id' }).inputProps,
        }}
        disabled // Disable the field completely so the user cannot interact with it
      />
      <TextField {...cSPTextFieldProps(itemNameProps)} />
      {/* <TextField {...cSPTextFieldProps(categoryNameProps)} /> */}

      {/* <TextField {...cSPTextFieldProps(UnitNameProps)} /> */}
      <TextField
        select
        {...cSPTextFieldProps({
          prop: 'unit_name',
          otherTextProps: { label: 'Unit Name' },
        })}
      >
        {unitList
          .filter(unit => unit.unit_type === values.quantity_type)
          .map(unit => (
            <MenuItem key={unit.id} value={unit.unit_name}>
              {unit.unit_name}
            </MenuItem>
          ))}
      </TextField>

      {/* <TextField {...cSPTextFieldProps(strainNameProps)} /> */}
      <TextField
        select
        {...cSPTextFieldProps({
          prop: 'strain_name',
          otherTextProps: { label: 'Strain Name' },
        })}
      >
        {strainList.map(strain => (
          <MenuItem key={strain.id} value={strain.strain_name}>
            {strain.strain_name}
          </MenuItem>
        ))}
      </TextField>
    </EntityDetailPopup>
  );
}
